import React, { useState, useImperativeHandle } from "react";
import "./styles.scss";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import Rows from "./DnDTables/SO";

import { useDidMountEffect } from "util";

const SOTable = (props, _ref) => {
    const { onChg, cycle,onOpen,soSelected,RevCmptCheckList } = props;
    const [_tblData, _setTblData] = useState([]);
    const [_isTblData, _setIsTblData] = useState(false);

    useImperativeHandle(_ref, () => ({
        setData: (data) => {
            _setTblData((d) => [...data]);
        },
    }));

    const seqCodeAlgorithm = () => {
        let array = [];
        let seqCode = 0;
        let startY = 0;
        let endY = startY;
        let isFlag = false;
        for (let i = 0; i <= _tblData.length; i++) {
            if (i !== _tblData.length && _tblData[i].repeat === "Y") {
                isFlag = true;
                endY++;
            } else {
                // 반복 시 startY, endY까지 찍는다.
                if (isFlag) {
                    let arrayTemp = new Array((endY - startY)).fill("");
                    for (let initRepeat = 0; initRepeat < cycle; initRepeat++) {
                        let indexY = 0; 
                        for (let y = startY; y < endY; y++) {
                            seqCode++;
                            if (initRepeat === cycle - 1) {
                                arrayTemp[indexY++] += (('00' + (seqCode)).slice(-2)+"A");
                            } else {
                                arrayTemp[indexY++] += (('00' + (seqCode)).slice(-2)+"A" + " ");
                            }
                            // Y 값
                        }
                    }
                    arrayTemp.forEach((arr) => {array.push(arr)})
                    seqCode++;
                    array.push((('00' + (seqCode)).slice(-2)+"A"))
                } else if (startY === 0) {
                    seqCode++
                    array.push((('00' + (seqCode)).slice(-2)+"A"));
                } else {
                    if (i === _tblData.length)
                        continue;
                    seqCode++;
                    array.push((('00' + (seqCode)).slice(-2)+"A"));
                }
                isFlag = false;
                startY = i + 1;
                endY = startY;
            }
        }
        _setTblData((T) => {

            return T.map((d,i) => {
                /*
                * 이동원 그룹장 요청으로 모든 code 보이게
                * return { ...d, seqCode: (array[i].toString().split(" ")[0] + (array[i].toString().split(" ").length > 1 ? " " + array[i].toString().split(" ")[array[i].toString().split(" ").length-1] : "")) };
                */
                
                return {...d, seqCode: array[i].toString().split(" ").join(",")
            }
            });
        });
    }

    useDidMountEffect(() => {
        // console창에 경고문 뜨는거 해결
        if (_isTblData) {
            onChg(_tblData);
            _setIsTblData(!_isTblData);
        } else {
            seqCodeAlgorithm();
            _setIsTblData(!_isTblData);
        }
    }, [_tblData, cycle]);

    const onOpenWrapper = (vv,uniqueCode,cmptCheck) => {
        if( cmptCheck )
            onOpen(vv,uniqueCode,_tblData,'SO');
    }


    if (_tblData.length > 0)
        return (
            <DndProvider backend={HTML5Backend}>
                <table id="so-table">
                    <colgroup>
                        <col width="40px" />
                        {/*<col width="10%" />*/}
                        <col width="30%" />
                        <col />
                        <col width="60px" />
                        <col width="1px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Seq</th>
                            {/*<th>Code</th>*/}
                            <th>Step Operation</th>
                            <th>Step Operation Description</th>
                            <th>Repeat</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {_tblData?.map((v, i) => {
                            return (
                                 <Rows
                                    index={i}
                                    rowData={v}
                                    key={"detailSO" + i} 
                                    onOpen = {onOpenWrapper}
                                    dataIndex={i}
                                    sheetType={"S"}
                                    soSelected = {soSelected}
                                    RevCmptCheckList = {RevCmptCheckList}
                                  />
                            );
                        })}
                    </tbody>
                </table>
            </DndProvider>
        );
    else return null;
};

export default React.forwardRef(SOTable);